import utils from '../../../../../components/Organisms/Form/utils'

import DropdownWrapper from 'src/views/Atoms/CountryDropdown/DropdownWrapper'

import { ConfigCompanyDetails } from '../../CorporateAccount/CompanyDetails/types'

const config = ({ countries, currencies }: ConfigCompanyDetails) =>  utils.injectTranslation({
  id: 'BankDetailsForm',
  path: 'onboarding.forms.IndividualAccount.BankDetailsForm.inputs',
  content: [
    {
      componentType: 'grid',
      props: {
        gridTemplateColumns: '1fr 1fr',
        marginTop: '32px'
      },
      content: [
        {
          componentType: 'input',
          props: {
            name: 'fullNameOfBank',
            required: true,
          },
        },
        {
          componentType: 'input',
          props: {
            name: 'bankStreetNo',
            required: true,
            isTextarea: true,
            textAreaHeight: '48px',
            textAreaPointerEvents: 'auto',
            resize: 'none'
          },
        },
      ],
    },
    {
      componentType: 'grid',
      props: {
        gridTemplateColumns: '1fr 1fr 1fr',
      },
      content: [
        {
          componentType: 'input',
          props: {
            name: 'bankCity',
            required: true,
          },
        },
        {
          componentType: 'input',
          props: {
            name: 'bankPostCode',
            required: true,
          },
        },
        {
          componentType: 'input',
          props: {
            name: 'bankCountry',
            required: true,
          },
          // @ts-ignore
          custom: props => DropdownWrapper({
            options: countries,
            name: 'bankCountry',
            label: 'onboarding.forms.IndividualAccount.BankDetailsForm.inputs.bankCountry.label',
            placeholder: 'onboarding.forms.IndividualAccount.BankDetailsForm.inputs.bankCountry.placeholder',
            bgTransparent: true,
            required: true,
            filter: true,
            ...props
          })
        },
        {
          componentType: 'input',
          props: {
            name: 'accountNumber',
            required: true,
          },
        },
        {
          componentType: 'input',
          props: {
            name: 'sortCode',
            required: true,
          },
        },
        {
          componentType: 'input',
          props: {
            name: 'currency',
            removeLabelEllipsis: true,
            minHeight: '0',
            gridArea: 'currency',
            required: true
          },
          // @ts-ignore
          custom: props => DropdownWrapper({
            options: currencies,
            name: 'currency',
            label: 'onboarding.forms.IndividualAccount.BankDetailsForm.inputs.currency.label',
            placeholder: 'onboarding.forms.IndividualAccount.BankDetailsForm.inputs.currency.placeholder',
            marginInputWrapper: '0 0 8px 0',
            filter: true,
            required: true,
            ...props
          })
        },
      ],
    },
  ],
})

export default config
